import * as R from "ramda";
import axios from 'axios'

const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;

function chg_cflag_str(src) {
    let _k = {};
    switch (src) {
        case "MAIN":
            _k.txt = "본책";
            _k.cls = "default";

            break;
        case "WB":
            _k.txt = "워크북";
            _k.cls = "warning";
            break;
        case "SUB_1":
            _k.txt = "부가/추가문제";
            _k.cls = "warning";
            break;
        case "SUB_2":
            _k.txt = "부가/어휘리스트";
            _k.cls = "danger";
            break;
        case "SUB_3":
            _k.txt = "부가/어휘테스트";
            _k.cls = "danger";
            break;

        default:
            _k.txt = "";
            _k.cls = "default";

    }
    return _k;
}

const chapterStore = {
    namespaced: true,
    state: {
        book_id: null,
        chapter: null,

        chapters: [],
        units: [],
        chaptertype_options: [
            { text: "본책", value: "MAIN" },
            { text: "워크북", value: "WB" },
            { text: "[부가자료] 추가문제", value: "SUB_1" },
            { text: "[부가자료] 어휘리스트", value: "SUB_2" },
            { text: "[부가자료] 어휘테스트", value: "SUB_3" },
        ],

        area: [],
        targets: [],
        enabled: [

            { cdnm: "허용", cd: "1" },
            { cdnm: "불가", cd: "0" },
        ]


    },
    mutations: {
        updateBookID(state, val) {
            state.book_id = val;
        },
        updateChapters(state, val) {
            state.chapters = val;
        },
        updateOneChapter(state, val) {
            state.chapter = val;
        },
        updateUnits(state, val) {
            state.units = val;
        }

    },
    actions: {
        async postChapter(context, payload) {
            let url = `${SERVER_URL}/unitmgr/ChapterOrUnit`;
            payload.book_id = parseInt(context.state.book_id);
            return axios.post(url, payload);
        },
        async putChapter(context, payload) {
            let url = `${SERVER_URL}/unitmgr/ChapterOrUnit/${payload.id}`;
            payload.book_id = parseInt(context.state.book_id);
            return axios.put(url, payload);
        },

        async postUnit(context, payload) {
            let url = `${SERVER_URL}/unitmgr/ChapterOrUnit`;
            payload.book_id = parseInt(context.state.book_id);
            return axios.post(url, payload);
        },
        async putUnit(context, payload) {
            let url = `${SERVER_URL}/unitmgr/ChapterOrUnit/${payload.id}`;
            payload.book_id = parseInt(context.state.book_id);
            return axios.put(url, payload);
        },


        removeChapter(context, payload) {
            let url = `${SERVER_URL}/unitmgr/ChapterOrUnit/${payload.id}`;
            return axios.delete(url, payload);
        },
        async getChapterList(context, query) {
            let url = `${SERVER_URL}/unitmgr/ChapterOrUnit?flag=${query.flag}&subflag=${query.subflag}&book_id=${query.book_id}`;
            let resp = await axios.get(url);
            let _pos = 0;
            let _k = R.map((item) => {
                _pos++;
                item.picked = false;
                item.vorder = _pos;
                let _k = chg_cflag_str(item.cflag);
                item.cflag_str = _k.txt;
                item.cflag_variant = _k.cls;
                return item;
            }, resp.data);
            context.state.chapters = _k;
        },

        async getUnitList(context, query) {

            let url = `${SERVER_URL}/unitmgr/ChapterOrUnit?flag=${query.flag}&subflag=${query.subflag}&book_id=${query.book_id}`;
            let resp = await axios.get(url);
            let _pos = 0;
            let _k = R.map((item) => {
                _pos++;
                item.picked = false;
                item.vorder = _pos;
                return item;
            }, resp.data);
            context.state.units = _k;
        },



        async orderChaperList(context, ids) {
            let payload = {};
            payload.book_id = parseInt(context.state.book_id);
            payload.ids = ids;
            let url = `${SERVER_URL}/unitmgr/ChapterOrder`;
            return axios.post(url, payload);
        },
        async orderUnitList(context, ids) {
            let payload = {};
            payload.chapter_id = parseInt(context.state.chapter.id);
            payload.ids = ids;
            let url = `${SERVER_URL}/unitmgr/UnitOrder`;
            return axios.post(url, payload);
        },

        async getAreaCode(context) {
            let url = `${SERVER_URL}/code?area=area`;
            let resp = await axios.get(url);
            let _pos = 0;
            // let _k = R.map((item) => {
            //     _pos++;
            //     item.picked = false;
            //     item.vorder = _pos;
            //     return item;
            // }, resp.data);
            context.state.area = resp.data;

        },
        async getTargetCode(context) {
            let url = `${SERVER_URL}/code?area=target`;
            let resp = await axios.get(url);
            let _pos = 0;
            // let _k = R.map((item) => {
            //     _pos++;
            //     item.picked = false;
            //     item.vorder = _pos;
            //     return item;
            // }, resp.data);
            context.state.targets = resp.data;

        }




    }
}


export default chapterStore;
